import { IConvertDataStratege } from '../interfaces/iConvertDataStratege'
import humps = require('humps');

class Camelizer implements IConvertDataStratege {
  convert(data: any) {
    return humps.camelizeKeys(data);
  }
}

export default new Camelizer();


// WEBPACK FOOTER //
// ./services/convertDataStrategies/classes/camelizer.ts